import { render, staticRenderFns } from "./FiveMinDataTable.vue?vue&type=template&id=ed7cf3be&scoped=true"
import script from "./FiveMinDataTable.vue?vue&type=script&lang=js"
export * from "./FiveMinDataTable.vue?vue&type=script&lang=js"
import style0 from "./FiveMinDataTable.vue?vue&type=style&index=0&id=ed7cf3be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed7cf3be",
  null
  
)

export default component.exports